export const positions = [

    {
      "symbol": "SNAP",
      "name": "Snap Inc.",
      "currency": "USD",
      "price": "13.52",
      "price_open": "13.18",
      "day_high": "13.65",
      "day_low": "12.71",
      "52_week_high": "18.36",
      "52_week_low": "4.82",
      "day_change": "0.34",
      "change_pct": "2.58",
      "close_yesterday": "13.18",
      "market_cap": "18647865344",
      "volume": "54048642",
      "volume_avg": "44871025",
      "shares": "1103779968",
      "stock_exchange_long": "New York Stock Exchange",
      "stock_exchange_short": "NYSE",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-24 16:01:50",
      "pe": "N/A",
      "eps": "-0.72"
  
    },
    {
      "symbol": "TWTR",
      "name": "Twitter, Inc.",
      "currency": "USD",
      "price": "30.75",
      "price_open": "31.86",
      "day_high": "32.39",
      "day_low": "30.51",
      "52_week_high": "45.86",
      "52_week_low": "26.26",
      "day_change": "-8.08",
      "change_pct": "-20.81",
      "close_yesterday": "38.83",
      "market_cap": "23770302464",
      "volume": "105075360",
      "volume_avg": "10571275",
      "shares": "773017984",
      "stock_exchange_long": "New York Stock Exchange",
      "stock_exchange_short": "NYSE",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-24 16:03:45",
      "pe": "10.16",
      "eps": "3.03"
  
    },
    {
      "symbol": "AAPL",
      "name": "Apple Inc.",
      "currency": "USD",
      "price": "246.58",
      "price_open": "243.16",
      "day_high": "246.72",
      "day_low": "242.89",
      "52_week_high": "246.72",
      "52_week_low": "142.00",
      "day_change": "3.00",
      "change_pct": "1.23",
      "close_yesterday": "243.58",
      "market_cap": "1114344259584",
      "volume": "15827692",
      "volume_avg": "20028962",
      "shares": "4519199744",
      "stock_exchange_long": "NASDAQ Stock Exchange",
      "stock_exchange_short": "NASDAQ",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-25 16:00:01",
      "pe": "20.94",
      "eps": "11.78"
  
    },
    {
      "symbol": "FB",
      "name": "Facebook, Inc.",
      "currency": "USD",
      "price": "187.89",
      "price_open": "185.83",
      "day_high": "189.00",
      "day_low": "185.09",
      "52_week_high": "208.66",
      "52_week_low": "123.02",
      "day_change": "1.51",
      "change_pct": "0.81",
      "close_yesterday": "186.38",
      "market_cap": "536040767488",
      "volume": "6979273",
      "volume_avg": "12925912",
      "shares": "2405720064",
      "stock_exchange_long": "NASDAQ Stock Exchange",
      "stock_exchange_short": "NASDAQ",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-25 16:00:01",
      "pe": "31.78",
      "eps": "5.91"
  
    },
    {
      "symbol": "GOOGL",
      "name": "Alphabet Inc.",
      "currency": "USD",
      "price": "1264.30",
      "price_open": "1252.00",
      "day_high": "1268.00",
      "day_low": "1249.15",
      "52_week_high": "1296.97",
      "52_week_low": "977.66",
      "day_change": "5.19",
      "change_pct": "0.41",
      "close_yesterday": "1259.11",
      "market_cap": "877319290880",
      "volume": "1243991",
      "volume_avg": "1160087",
      "shares": "299532000",
      "stock_exchange_long": "NASDAQ Stock Exchange",
      "stock_exchange_short": "NASDAQ",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-25 16:00:01",
      "pe": "25.52",
      "eps": "49.54"
  
    },
    {
      "symbol": "MSFT",
      "name": "Microsoft Corporation",
      "currency": "USD",
      "price": "140.73",
      "price_open": "139.34",
      "day_high": "141.14",
      "day_low": "139.20",
      "52_week_high": "142.37",
      "52_week_low": "93.96",
      "day_change": "0.79",
      "change_pct": "0.56",
      "close_yesterday": "139.94",
      "market_cap": "1094723174400",
      "volume": "20464765",
      "volume_avg": "26070562",
      "shares": "7695349760",
      "stock_exchange_long": "NASDAQ Stock Exchange",
      "stock_exchange_short": "NASDAQ",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-25 16:00:01",
      "pe": "26.55",
      "eps": "5.30"
  
    },
    {
      "symbol": "INTC",
      "name": "Intel Corporation",
      "currency": "USD",
      "price": "56.46",
      "price_open": "54.19",
      "day_high": "56.61",
      "day_low": "53.95",
      "52_week_high": "59.59",
      "52_week_low": "42.86",
      "day_change": "4.23",
      "change_pct": "8.10",
      "close_yesterday": "52.23",
      "market_cap": "252583968768",
      "volume": "56704514",
      "volume_avg": "16469900",
      "shares": "4430000128",
      "stock_exchange_long": "NASDAQ Stock Exchange",
      "stock_exchange_short": "NASDAQ",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-25 16:00:01",
      "pe": "13.11",
      "eps": "4.31"
  
    },
    {
      "symbol": "CRM",
      "name": "salesforce.com, inc.",
      "currency": "USD",
      "price": "150.49",
      "price_open": "147.05",
      "day_high": "150.66",
      "day_low": "146.30",
      "52_week_high": "167.56",
      "52_week_low": "113.60",
      "day_change": "2.37",
      "change_pct": "1.60",
      "close_yesterday": "148.12",
      "market_cap": "131979730944",
      "volume": "4814264",
      "volume_avg": "5236950",
      "shares": "877000000",
      "stock_exchange_long": "New York Stock Exchange",
      "stock_exchange_short": "NYSE",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-25 16:01:48",
      "pe": "124.99",
      "eps": "1.20"
  
    },
    {
      "symbol": "CSCO",
      "name": "Cisco Systems, Inc.",
      "currency": "USD",
      "price": "46.90",
      "price_open": "46.54",
      "day_high": "46.99",
      "day_low": "46.46",
      "52_week_high": "58.26",
      "52_week_low": "40.25",
      "day_change": "0.49",
      "change_pct": "1.06",
      "close_yesterday": "46.41",
      "market_cap": "196328095744",
      "volume": "12554651",
      "volume_avg": "16144737",
      "shares": "4243830016",
      "stock_exchange_long": "NASDAQ Stock Exchange",
      "stock_exchange_short": "NASDAQ",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-25 16:00:01",
      "pe": "17.97",
      "eps": "2.61"
  
    },
    {
      "symbol": "ORCL",
      "name": "Oracle Corporation",
      "currency": "USD",
      "price": "54.17",
      "price_open": "54.04",
      "day_high": "54.42",
      "day_low": "54.01",
      "52_week_high": "60.50",
      "52_week_low": "42.40",
      "day_change": "-0.09",
      "change_pct": "-0.17",
      "close_yesterday": "54.26",
      "market_cap": "177814110208",
      "volume": "5741404",
      "volume_avg": "9189612",
      "shares": "3288329984",
      "stock_exchange_long": "New York Stock Exchange",
      "stock_exchange_short": "NYSE",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-25 16:03:50",
      "pe": "17.73",
      "eps": "3.06"
  
    },
    {
      "symbol": "SAP",
      "name": "SAP SE",
      "currency": "USD",
      "price": "131.87",
      "price_open": "131.35",
      "day_high": "132.18",
      "day_low": "130.96",
      "52_week_high": "140.62",
      "52_week_low": "94.81",
      "day_change": "0.08",
      "change_pct": "0.06",
      "close_yesterday": "131.79",
      "market_cap": "162669559808",
      "volume": "558142",
      "volume_avg": "1046450",
      "shares": "1228499968",
      "stock_exchange_long": "New York Stock Exchange",
      "stock_exchange_short": "NYSE",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-25 16:04:17",
      "pe": "31.86",
      "eps": "4.14"
  
    },
    {
      "symbol": "TSM",
      "name": "Taiwan Semiconductor Manufacturing Company Limited",
      "currency": "USD",
      "price": "51.13",
      "price_open": "50.80",
      "day_high": "51.23",
      "day_low": "50.69",
      "52_week_high": "51.23",
      "52_week_low": "34.21",
      "day_change": "0.18",
      "change_pct": "0.35",
      "close_yesterday": "50.95",
      "market_cap": "250063552512",
      "volume": "5965678",
      "volume_avg": "9484987",
      "shares": "5186079744",
      "stock_exchange_long": "New York Stock Exchange",
      "stock_exchange_short": "NYSE",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-25 16:01:26",
      "pe": "22.93",
      "eps": "2.23"
  
    },
    {
      "symbol": "ACN",
      "name": "Accenture plc",
      "currency": "USD",
      "price": "183.07",
      "price_open": "184.67",
      "day_high": "184.83",
      "day_low": "183.02",
      "52_week_high": "202.80",
      "52_week_low": "132.63",
      "day_change": "-1.93",
      "change_pct": "-1.04",
      "close_yesterday": "185.00",
      "market_cap": "116597284864",
      "volume": "1369124",
      "volume_avg": "1892150",
      "shares": "636000000",
      "stock_exchange_long": "New York Stock Exchange",
      "stock_exchange_short": "NYSE",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-25 16:00:12",
      "pe": "24.87",
      "eps": "7.36"
  
    },
    {
      "symbol": "ADBE",
      "name": "Adobe Inc.",
      "currency": "USD",
      "price": "270.98",
      "price_open": "267.80",
      "day_high": "271.61",
      "day_low": "267.02",
      "52_week_high": "313.11",
      "52_week_low": "204.95",
      "day_change": "1.28",
      "change_pct": "0.47",
      "close_yesterday": "269.70",
      "market_cap": "131175735296",
      "volume": "1511852",
      "volume_avg": "3342325",
      "shares": "484079008",
      "stock_exchange_long": "NASDAQ Stock Exchange",
      "stock_exchange_short": "NASDAQ",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-25 16:00:01",
      "pe": "48.22",
      "eps": "5.62"
  
    },
    {
      "symbol": "AVGO",
      "name": "Broadcom Inc.",
      "currency": "USD",
      "price": "289.82",
      "price_open": "283.26",
      "day_high": "291.37",
      "day_low": "283.22",
      "52_week_high": "323.20",
      "52_week_low": "208.23",
      "day_change": "7.51",
      "change_pct": "2.66",
      "close_yesterday": "282.31",
      "market_cap": "114963193856",
      "volume": "1987976",
      "volume_avg": "1691400",
      "shares": "396671008",
      "stock_exchange_long": "NASDAQ Stock Exchange",
      "stock_exchange_short": "NASDAQ",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-25 16:00:01",
      "pe": "40.79",
      "eps": "7.11"
  
    },
    {
      "symbol": "IBM",
      "name": "International Business Machines Corporation",
      "currency": "USD",
      "price": "135.44",
      "price_open": "134.12",
      "day_high": "135.93",
      "day_low": "134.10",
      "52_week_high": "152.95",
      "52_week_low": "105.94",
      "day_change": "1.37",
      "change_pct": "1.02",
      "close_yesterday": "134.07",
      "market_cap": "119982915584",
      "volume": "2543592",
      "volume_avg": "5996562",
      "shares": "885875008",
      "stock_exchange_long": "New York Stock Exchange",
      "stock_exchange_short": "NYSE",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-25 16:00:04",
      "pe": "14.23",
      "eps": "9.52"
  
    },
    {
      "symbol": "NVDA",
      "name": "NVIDIA Corporation",
      "currency": "USD",
      "price": "204.54",
      "price_open": "200.10",
      "day_high": "205.38",
      "day_low": "199.79",
      "52_week_high": "222.00",
      "52_week_low": "124.46",
      "day_change": "7.68",
      "change_pct": "3.90",
      "close_yesterday": "196.86",
      "market_cap": "122178895872",
      "volume": "10357677",
      "volume_avg": "8645212",
      "shares": "609000000",
      "stock_exchange_long": "NASDAQ Stock Exchange",
      "stock_exchange_short": "NASDAQ",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-25 16:00:01",
      "pe": "46.12",
      "eps": "4.44"
  
    },
    {
      "symbol": "ASML",
      "name": "ASML Holding N.V.",
      "currency": "USD",
      "price": "263.99",
      "price_open": "262.45",
      "day_high": "264.70",
      "day_low": "261.88",
      "52_week_high": "269.39",
      "52_week_low": "144.50",
      "day_change": "-0.98",
      "change_pct": "-0.37",
      "close_yesterday": "264.97",
      "market_cap": "110834614272",
      "volume": "549797",
      "volume_avg": "1164687",
      "shares": "421143008",
      "stock_exchange_long": "NASDAQ Stock Exchange",
      "stock_exchange_short": "NASDAQ",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-25 16:00:01",
      "pe": "37.94",
      "eps": "6.96"
  
    },
    {
      "symbol": "INTU",
      "name": "Intuit Inc.",
      "currency": "USD",
      "price": "257.67",
      "price_open": "259.13",
      "day_high": "260.28",
      "day_low": "256.70",
      "52_week_high": "295.77",
      "52_week_low": "182.61",
      "day_change": "-1.23",
      "change_pct": "-0.48",
      "close_yesterday": "258.90",
      "market_cap": "67013271552",
      "volume": "1038001",
      "volume_avg": "1170162",
      "shares": "260074000",
      "stock_exchange_long": "NASDAQ Stock Exchange",
      "stock_exchange_short": "NASDAQ",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-25 16:00:01",
      "pe": "43.75",
      "eps": "5.89"
  
    },
    {
      "symbol": "QCOM",
      "name": "QUALCOMM Incorporated",
      "currency": "USD",
      "price": "80.17",
      "price_open": "79.00",
      "day_high": "80.23",
      "day_low": "78.91",
      "52_week_high": "90.34",
      "52_week_low": "49.10",
      "day_change": "1.18",
      "change_pct": "1.49",
      "close_yesterday": "78.99",
      "market_cap": "97459462144",
      "volume": "5950509",
      "volume_avg": "5573175",
      "shares": "1215660032",
      "stock_exchange_long": "NASDAQ Stock Exchange",
      "stock_exchange_short": "NASDAQ",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-25 16:00:01",
      "pe": "29.34",
      "eps": "2.73"
  
    },
    {
      "symbol": "SNE",
      "name": "Sony Corporation",
      "currency": "USD",
      "price": "58.51",
      "price_open": "58.23",
      "day_high": "58.62",
      "day_low": "58.03",
      "52_week_high": "60.74",
      "52_week_low": "41.91",
      "day_change": "-0.12",
      "change_pct": "-0.20",
      "close_yesterday": "58.63",
      "market_cap": "71632035840",
      "volume": "670753",
      "volume_avg": "757475",
      "shares": "1234150016",
      "stock_exchange_long": "New York Stock Exchange",
      "stock_exchange_short": "NYSE",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-25 16:02:00",
      "pe": "12.30",
      "eps": "4.76"
  
    },
    {
      "symbol": "TXN",
      "name": "Texas Instruments Incorporated",
      "currency": "USD",
      "price": "120.51",
      "price_open": "118.51",
      "day_high": "120.68",
      "day_low": "118.51",
      "52_week_high": "132.20",
      "52_week_low": "87.70",
      "day_change": "2.10",
      "change_pct": "1.77",
      "close_yesterday": "118.41",
      "market_cap": "112698302464",
      "volume": "4106890",
      "volume_avg": "6018987",
      "shares": "933619968",
      "stock_exchange_long": "NASDAQ Stock Exchange",
      "stock_exchange_short": "NASDAQ",
      "timezone": "EDT",
      "timezone_name": "America/New_York",
      "gmt_offset": "-14400",
      "last_trade_time": "2019-10-25 16:00:01",
      "pe": "22.37",
      "eps": "5.39"
  
    }
  
  ];